import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import CurrencyFormat from "react-currency-format";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import BoxItem from "@/app/core/layouts/main-components/delivery/BoxItem";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";

export default function BoxesStep({ infos, reportBoxes, goBack, quotation }) {
    const [data, setData] = useState([]);
    const [box, setBox] = useState({});
    const [isNational, setIsNational] = useState(true);
    const [brazilian, setBrazilian] = useState(false);
    const date = new Date();
    const [change, setChange] = useState(date.getTime());

    useEffect(() => {
        loadInfos()
        console.log("Caixas", quotation)
    }, [infos, quotation])

    useEffect(() => {
        notifyChange()
    }, [data])

    function notifyChange() {
        setChange(date.getTime());
    }

    function loadInfos() {
        if (DeliveryHelper().IsNational(infos, "BR") == false) {
            setBrazilian(false);
        } else if (DeliveryHelper().IsNational(infos, "BR")) {
            setBrazilian(true);
        }
        if (infos && infos.boxes != undefined) {
            setData(infos.boxes);
            if (DeliveryHelper().IsNational(infos, "BR") == false && quotation && quotation.type == "not_doc") {
                setIsNational(false);
            } else {
                setIsNational(true);
            }
        }

    }

    function endBoxes() {
        if (data.length == 0) {
            toast.error("Cadastre ao menos uma caixa para prosseguir");
        } else {
            let items = data.filter(x => x.items && x.items.length > 0);
            if (quotation.object == "not_doc" && items.length == 0) {
                toast.error("Cadastre ao menos 1 produto para prosseguir")
            } else {
                reportBoxes(data);
            }
        }
    }


    function addPackage(full) {
        let size = "4";
        if (full) {
            size = "12"
        }
        return (
            <div className="row">
                <div className={`form-group col-md-${size}`}>
                    <span>*{Translate(Message.BoxName)}</span>
                    <input className="form-control" name="name" value={box && box.name} onChange={evt => handlePackageChange(evt)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*{Translate(Message.BoxDepth)}</span>
                    <input type="number" className="form-control" name="depth" value={box && box.depth} onChange={evt => handlePackageChange(evt, FieldTypeObj.Decimal)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*{Translate(Message.BoxWidth)}</span>
                    <input type="number" className="form-control" name="width" value={box && box.width} onChange={evt => handlePackageChange(evt, FieldTypeObj.Decimal)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*{Translate(Message.BoxHeight)}</span>
                    <input type="number" className="form-control" name="height" value={box && box.height} onChange={evt => handlePackageChange(evt, FieldTypeObj.Decimal)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*{Translate(Message.BoxWeight)}</span>
                    <input type="number" className="form-control" name="weight" value={box && box.weight} onChange={evt => handlePackageChange(evt, FieldTypeObj.Decimal)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*{Translate(Message.BoxContent)}</span>
                    <input type="number" className="form-control" name="price" value={box && box.price} onChange={evt => handlePackageChange(evt, FieldTypeObj.Currency)} />
                    {/* <CurrencyFormat
                        className={`form-control`}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        name="price"
                        value={box.price}
                        prefix={"R$"}
                        onValueChange={(values) => {
                            const { formattedValue, value } = values;
                            handlePackageChange({ target: { value: value, name: "price" } }, FieldTypeObj.Currency)
                        }} /> */}
                    <small>{Translate(Message.BoxInsurance)}</small>
                </div>
                <div className="col-md-12 text-center mt-0">
                    <button className="btn btn-success" onClick={() => addBox()}>
                        <i className="si si-check mr-2" />
                        {Translate(Message.Add)}
                    </button>
                </div>
            </div>
        )
    }

    function handlePackageChange(evt, type) {
        setBox(OnDataChange(box, evt, type));
    }


    function addBox() {
        if (box.height == "" || box.height == undefined ||
            box.width == "" || box.width == undefined ||
            box.depth == "" || box.depth == undefined ||
            box.weight == "" || box.weight == undefined) {
            toast.error(Message.PendingData);
        } else {
            setData([...data, { ...box, id: data.length + 1 }]);
            setBox({});
        }
    }

    function duplicateBox(item) {
        setData([...data, item]);
    }

    function handleItens(items, index) {
        let old = data;
        old[index].items = items;
        setData(old);
    }

    function removeBox(pos) {
        if (window.confirm(Translate(Message.DeleteConfirm))) {
            setData(data.filter((x, index) => index != pos));
        }
    }

    function handleBox(item, index) {
        let newData = data;
        newData[index] = item;
        setData(newData);
        notifyChange();
    }

    return (
        <div className="row">
            <div className="block block-rounded block-bordered block-fx-pop mb-0 border-success col-md-12" key={`card-boxes`}>
                <div className="block-header">
                    <div className="block-title">
                        <i className="fa fa-boxes text-success mr-2"></i>{Translate(Message.Boxes)}
                    </div>
                    <div className="block-tools">
                        <Dropdown>
                            <Dropdown.Toggle>
                                {Translate(Message.AddBox)}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {addPackage(true)}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <div className="ml-2 mr-2 mb-2">
                    {change && data && data.length == 0 ?
                        <div className="block  block-bordered border-info p-1 pb-3 col-12">
                            <div className="block-header">
                                <div className="block-title">{Translate(Message.BoxDefinition)}</div>
                            </div>
                            {addPackage()}
                        </div>
                        : ""}
                    {change && data && data.map((item, index) => (
                        <BoxItem data={item}
                            hideContent={quotation}
                            delivery={data}
                            removeBox={() => removeBox(index)}
                            duplicate={() => duplicateBox(item)}
                            report={itens => handleItens(itens, index)}
                            reportBox={itens => handleBox(itens, index)}
                            isNational={brazilian} />
                    ))}
                </div>
            </div>
            <div className="col-12 text-center mt-5">
                <button type="button" className="btn btn-hero-lg btn-hero-white" onClick={() => goBack()}>
                    <i className="fa fa-arrow-left mr-2"></i> {Translate(Message.GoBack)}
                </button>
                <button type="button" className="btn btn-hero-lg btn-hero-success" onClick={() => endBoxes()}>
                    {Translate(Message.Advance)} <i className="fa fa-arrow-right ml-2"></i>
                </button>
            </div>
        </div>
    )
}